/**
 * Query Provider
 *
 * Wraps the application with TanStack Query's QueryClientProvider.
 * Includes React Query Devtools in development mode.
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '../lib/queryClient';

interface QueryProviderProps {
  children: React.ReactNode;
}

/**
 * QueryProvider component
 *
 * Provides React Query context to the entire application.
 * Devtools are only rendered in development mode.
 *
 * @param props - Component props
 * @param props.children - Child components to wrap
 */
export function QueryProvider({ children }: QueryProviderProps): React.ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {import.meta.env.DEV && (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      )}
    </QueryClientProvider>
  );
}
